<script>
import HorizontalTopbar from "@/components/horizontal-topbar";
// import HorizontalNav from "@/components/horizontal-nav";
import RightBar from "@/components/right-bar";
import Footer from "@/components/footer";
import NprogressContainer from 'vue-nprogress/src/NprogressContainer'
import MobileFooter from "@/components/mobile-login-footer"

import { layoutComputed } from "@/state/helpers";

/**
 * Horizontal-layout
 */
export default {
  components: {
    HorizontalTopbar,
    // HorizontalNav,
    Footer,
    NprogressContainer,
    RightBar,
    MobileFooter
  },
  data() {
    return {};
  },
  computed: {
    ...layoutComputed,
     userFullName() {
      return this.$cookies.isKey('userFullName') ? this.$cookies.get('userFullName') : '';      
    }, 

  },
  created: () => {
    document.body.setAttribute("data-layout", "horizontal");
    document.body.setAttribute("data-topbar", "dark");
    document.body.removeAttribute("data-sidebar");
    document.body.removeAttribute("data-layout-size");
    document.body.classList.remove("auth-body-bg");
  },
  methods: {
    toggleRightSidebar() {
      document.body.classList.toggle("right-bar-enabled");
    },
    hideRightSidebar() {
      document.body.classList.remove("right-bar-enabled");
    },
  },
  mounted() {
      
    //document.body.style.background=  this.$route.name === 'default' ? '#fff' : '#f8f8fb';
    
    if (this.loader === true) {
      document.getElementById("preloader").style.display = "block";
      document.getElementById("status").style.display = "block";

      setTimeout(function () {
        document.getElementById("preloader").style.display = "none";
        document.getElementById("status").style.display = "none";
      }, 2500);
    } else {
      document.getElementById("preloader").style.display = "none";
      document.getElementById("status").style.display = "none";
    }
  },
};
</script>

<style lang="scss">
  
  #nprogress .bar {
    background: #1d3266;// #f2b44d;
    height: 4px;
  }

  #nprogress .spinner-icon {
  border: solid 4px transparent;
  border-top-color: #1d3266;
  border-left-color: #1d3266;
  }

  #nprogress .peg {
  box-shadow: 0 0 10px grey, 0 0 5px grey;
  //box-shadow: 0 0 10px #d11010, 0 0 5px #d11010;
  opacity: 1.0;
  }

  @media all and (max-width: 1024px) {
    .container-fluid {
        padding-left: 20px !important;
        padding-right: 20px !important;
    } 
  }

</style>

<template>
  <div>
    <div id="preloader">
      <div id="status">
        <div class="spinner-chase">
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
        </div>
      </div>
    </div>
    <!-- Begin page -->
    <div id="layout-wrapper">
      <!-- :style=" !userFullName || $route.name != 'default'   ? '' : 'background-color: transparent;     position: absolute;' " -->
      <HorizontalTopbar :type="topbar" :width="layoutWidth" />
      <!-- <HorizontalNav /> -->
      <vue-snotify></vue-snotify>
      <!-- ============================================================== -->
      <!-- Start right Content here -->
      <!-- ============================================================== -->
      <!-- <div class="main-content " :class="!userFullName || $route.name != 'default'  ? 'mt-4' : ''"> -->
      <div class="main-content " :class="this.$route.name === 'default' ||  this.$route.name === 'Offre DigiTable' ? '' : this.userFullName == ''  ? '' : 'mt-4'"> 
        <div class="nprogress-container page-content" :class="this.$route.name === 'default' ||  this.$route.name === 'Offre DigiTable' ? '' : this.userFullName == '' ? 'page-content-full-width page-content' : '' ">
        <nprogress-container></nprogress-container>
        <!-- Start Content-->
        <div id="containerfluid" :class="this.$route.name === 'default' ? 'container-fluid-full-width' : ''">
          <slot />
          </div>
        </div>
        <!-- End Page-content -->
        <Footer />
        <MobileFooter />
      </div>
      <!-- end main content-->
    </div>
    <!-- END layout-wrapper -->
    <RightBar />
  </div>
</template>